import jwt_decode from "jwt-decode";
import apps from "../constants/Apps";

export default {
    getAPIEndpoint: (endPoint: string, params = null) => {
        let actualEndpoint = endPoint;
        if (params) {
            if (typeof (params) === 'object') {
                let url = endPoint;
            }
            actualEndpoint = endPoint.replace('<>', params);
        }
        return actualEndpoint;
    },

    getCookie: (name: string) => {
        return document.cookie.split("; ").reduce((r, v) => {
            const parts = v.split("=");
            return parts[0] === name ? decodeURIComponent(parts[1]) : r;
        }, "");
    },

    deleteCookie: (name: string) => {
        document.cookie = name + '=;expires=Thu, 01 Jan 1970 00:00:01 GMT; path=/';
    },

    fuzzySearch: (text: string, search: string) => {
        /*
            Parameter text is a title, search is the user's search
        */
        // remove spaces, lower case the search so the search
        // is case insensitive
        var search = search.replace(/\ /g, '').toLowerCase();
        var tokens = [];
        var search_position = 0;

        // Go through each character in the text
        for (var n = 0; n < text.length; n++) {
            var text_char = text[n];
            // if we match a character in the search, highlight it
            if (search_position < search.length &&
                text_char.toLowerCase() == search[search_position]) {
                text_char = '<b>' + text_char + '</b>';
                search_position += 1;
            }
            tokens.push(text_char);
        }
        // If are characters remaining in the search text,
        // return an empty string to indicate no match
        if (search_position != search.length) {
            return '';
        }
        return tokens.join('');
    },

    scrollTo : (el : string, offset : number) => {
		var element : any = document.getElementById(el);
		var headerOffset = offset;
		var elementPosition = element.getBoundingClientRect().top;
		var offsetPosition = elementPosition + window.pageYOffset - headerOffset;
	
		window.scrollTo({
			top: offsetPosition,
			behavior: "smooth"
		});
	},

    decodeToken : (token : string) => {
        const decoded = jwt_decode(token);
        return decoded;
    },

    consoleLog : (data : any) => {
        if(process.env.NEXT_PUBLIC_APP_ENVIRONMENT === 'DEVELOPMENT') 
            console.log(data);
    },

    getLayout : () => { 
        const subdomain = window.location.hostname.split('.').slice(0, -1).join('.');        
        const layout = apps.find((app : any) => {
            return subdomain !== 'www' && app.subdomains.includes(subdomain);
        });
        
        if(!layout)
            return apps[0].component;
    
        return layout.component;
    },

    checkPathAndGetURL__middleware : (URL_ARRAY : string[], path : string) => {
        const url = URL_ARRAY.find(page => {
            if(page.includes('path')) {
                const index = page.indexOf(':path');
                const slicedPath = page.slice(0, index);
                const slicedCurrentPath = path.slice(0, index); 
                return (slicedPath == slicedCurrentPath)
            }
            return (path == page);
        });
        return url;
    },

    reduceStringLength : (word : string, length : number = 10) => {
        let result = ''
        if(!word)
            return result;
            
        if(word.length > length) {
            result = word.slice(0, length);
            result = `${result}...`
        }
        else
            result = word
        return result;
    }
}